import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs/Rx';
import { ConfigService } from './config-service';
import { JwtHelper } from 'angular2-jwt';

import 'rxjs/add/operator/mergeMap';

@Injectable()
export class TokenFactory {
    private router: Router;
    private configService: ConfigService;
    private jwtHelper: JwtHelper;
    private httpClient: HttpClient;

    private _tokenUpdate: Subject<void>;
    public get tokenUpdate(): Subject<void> {
        return this._tokenUpdate;
    }

    constructor(private injector: Injector) {
        if (!this.jwtHelper) {
            this.jwtHelper = this.injector.get(JwtHelper);
        }

        if (!this.configService) {
            this.configService = this.injector.get(ConfigService);
        }

        if (!this.router) {
            this.router = this.injector.get(Router);
        }

        if (!this.httpClient) {
            this.httpClient = this.injector.get(HttpClient);
        }
    }

    validateToken(): Promise<string> {
        return new Promise<any>((success, failed) => {
            const currentToken = this.getCurrentAccessToken();
            const decodedToken = this.jwtHelper.decodeToken(currentToken.access_token);
            const expireThreshold = (new Date().getTime() / 1000) + 300;
            if (expireThreshold > decodedToken.exp) {
                return this.updateToken(currentToken.refresh_token)
                    .subscribe(() => {
                        try {
                            success(this.getCurrentAccessToken().access_token);
                        } catch (error) {
                            this.router.navigateByUrl('/login');
                            failed(error);
                        };
                    });
            } else {
                success(currentToken.access_token);
            }
        });
    }

    updateToken(refreshToken: string): Observable<void> {
        if (this._tokenUpdate !== null && this._tokenUpdate !== undefined) {
            return this._tokenUpdate;
        }

        this._tokenUpdate = new Subject<void>();
        const clientId = this.configService.getEnv('oauthClientId');
        const refreshUrl = this.configService.getEnv('accountApi');

        const body = `client_id=${clientId}&grant_type=refresh_token&refresh_token=${refreshToken}`;
        const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'no-auth': 'true' });

        return this.httpClient.post(`${refreshUrl}token`, body, { headers: headers })
            .map((result: any) => {
                localStorage.setItem('token', JSON.stringify(result));
                this._tokenUpdate.next();
                this._tokenUpdate = null;
            })
            .catch((error: any) => {
                localStorage.removeItem('token');
                this._tokenUpdate.error(error);
                this._tokenUpdate = null;
                return Observable.throw(error);
            });
    }

    getCurrentAccessToken(): any {
        return JSON.parse(localStorage.getItem('token'));
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/token-factory.ts